<template>
  <div class="nhbr-labor-input row">
    <div class="col-md-6">
      <label :for="`input-value-${inputKey}`">Érték:</label>
      <b-form-input 
        :id="`nput-value-${inputKey}`"
        placeholder="Érték" 
        type="text"
        :class="isValidField.ertek ? '' : 'nhbr-invalid'" 
        :value="value.ertek"
        @change="onInputChanged($event.replace(',', '.'), 'ertek')"
      />
    </div>

    <div class="col-md-6" v-if="inputKey !== 'fk_kappa_lambda_arany'">
      <label :for="`input-metric-${inputKey}`">Mértékegység:</label>
      <b-form-input 
        :id="`nput-metric-${inputKey}`"
        placeholder="Mértékegység" 
        type="text"
        :class="isValidField.mertekegyseg ? '' : 'nhbr-invalid'" 
        :value="value.mertekegyseg"
        @change="onInputChanged($event, 'mertekegyseg')"
      />
    </div>

    <div class="col-md-6">
      <label :for="`input-normal-min-${inputKey}`">Normál Min:</label>
      <b-form-input  
        :id="`nput-normal-min-${inputKey}`"
        placeholder="Normál Min" 
        type="text"
        :class="isValidField.normal_min ? '' : 'nhbr-invalid'" 
        :value="value.normal_min"
        @change="onInputChanged($event.replace(',', '.'), 'normal_min')"
      />
    </div>

    <div class="col-md-6">
      <label :for="`input-normal-max-${inputKey}`">Normál Max:</label>
      <b-form-input 
        :id="`nput-normal-max-${inputKey}`"
        placeholder="Normál Max" 
        type="text"
        :class="isValidField.normal_max ? '' : 'nhbr-invalid'" 
        :value="value.normal_max"
        @change="onInputChanged($event.replace(',', '.'), 'normal_max')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'nhbr-labor-input',
  data() {
    return {
      laborInputs: {
        normal_min: null,
        normal_max: null,
        ertek: null,
        mertekegyseg: null
      }
    }
  },
  props: {
    inputKey: {
      type: String
    },
    value: {
      type: Object
    },
    isValidField: {
      type: Object
    }
  },
  methods: {
    onInputChanged(event, sourceId) {
      this.laborInputs[sourceId] = !isNaN(event) ? Number(event) : event
      
      this.$emit('inputChanged', this.laborInputs)

      // Save labor metrics to cache
      localStorage.setItem('nhbr_labor_metrics_' + this.inputKey, JSON.stringify(
        {
          normal_min: Number(this.laborInputs.normal_min),
          normal_max: Number(this.laborInputs.normal_max),
          mertekegyseg: this.laborInputs.mertekegyseg
        }
      ))
    }
  },
  mounted() {
    // Get labor metrics from local storage cache if exists
    const laborMetrics = localStorage.getItem('nhbr_labor_metrics_' + this.inputKey)
    if (laborMetrics) {
      const laborMetricsObject = JSON.parse(laborMetrics)
      this.laborInputs = {
        ...this.laborInputs,
        ...laborMetricsObject
      }
      this.$emit('inputChanged', this.laborInputs)
    }
  }
}
</script>

<style scoped lang="scss">
/*** Component Style ***/
.nhbr-labor-input {
  position: relative;

  div {
    margin-bottom: 12px;

    label {
      font-size: 14px;
    }
  }
}
</style>